interface IOrderForm {
    paymentId: number
}

export interface IConfirmedOrderResponse {
    errorMsg: string;
    paymentProviderInternalData: string;
}

export class VippsHurtigkasseController {
    private _orderForm: IOrderForm = { paymentId: 71 };

    public async startExpressCheckout(): Promise<IConfirmedOrderResponse> {
        const payload = {
            method: 'POST',
            body: JSON.stringify(this._orderForm),
            headers: { 'Content-Type': 'application/json' },
            cache: 'no-cache'
        } as any;

        const response = await fetch('/api/checkout/order/create-and-confirm-initialized', payload);

        const confirmedOrderResponse = await response.json() as IConfirmedOrderResponse;

        return confirmedOrderResponse;
    }
}